export enum CateringEmailSubject {
  CATERING_INQUIRY_INFORMATION = 'Catering inquiry information',
  PAYMENT_PROCESSING_CONFIRMATION = 'Payment processing confirmation',
  ORDER_REJECTION = 'Order rejection',
  // REFUND_NOTIFICATION = 'Refund notification',
  MANUAL_INVOICE_NOTIFICATION = 'Manual invoice notification',
  ORDER_CONFIRMATION = 'Order confirmation',
  FINAL_PAYMENT_CONFIRMATION = 'Final payment confirmation',
  DEPOSIT_PAYMENT_SUCCESS = 'Deposit payment success',
  NEW_INQUIRY_NOTIFICATION = 'New inquiry notification',
  PAYMENT_REMINDER = 'Payment reminder',
  ORDER_EDIT_CONFIRMATION_REQUEST = 'Order edit confirmation request',
  POST_EVENT_FEEDBACK_REQUEST = 'Post event feedback request',
}

export interface ICateringEmailContent {
  subject: CateringEmailSubject;
  heading: string;
  text: string;
  emailTo: string;
  status: string;
  buttonText?: string;
}

export const cateringEmails: ICateringEmailContent[] = [
  {
    subject: CateringEmailSubject.CATERING_INQUIRY_INFORMATION,
    heading: 'Thank you',
    text: 'Thank you for your catering inquiry. We’ll be in touch soon!',
    emailTo: 'Customer',
    status: 'Inquiry submitted',
  },
  {
    subject: CateringEmailSubject.PAYMENT_PROCESSING_CONFIRMATION,
    heading: 'Payment received.',
    text: 'Thank you!',
    emailTo: 'Restaurant',
    status: 'Payment processed',
  },
  {
    subject: CateringEmailSubject.ORDER_REJECTION,
    heading: 'Order rejection',
    text: 'Update on your catering inquiry',
    emailTo: 'Customer',
    status: 'Order rejected',
  },
  // {
  //   subject: CateringEmailSubject.REFUND_NOTIFICATION,
  //   heading: 'Refund',
  //   text: 'Refund processed for your order',
  //   emailTo: 'Customer',
  //   status: 'Refund processed',
  // },
  {
    subject: CateringEmailSubject.MANUAL_INVOICE_NOTIFICATION,
    heading: 'Update',
    text: 'Invoice #{Invoice number} for your catering order',
    emailTo: 'Customer',
    status: 'Invoice sent',
  },
  {
    subject: CateringEmailSubject.ORDER_CONFIRMATION,
    heading: 'Great news!',
    text: 'Your catering order has been confirmed',
    emailTo: 'Customer',
    status: 'Order confirmed',
  },
  {
    subject: CateringEmailSubject.FINAL_PAYMENT_CONFIRMATION,
    heading: 'Update',
    text: 'Payment received for your catering order. Thank you!',
    emailTo: 'Customer',
    status: 'Final payment paid',
  },
  // {
  //   subject: CateringEmailSubject.DEPOSIT_PAYMENT_SUCCESS,
  //   heading: 'Update',
  //   text: 'Deposit received. Your catering order is secured!',
  //   emailTo: 'Customer',
  //   status: 'Deposit paid',
  // },
  // {
  //   subject: CateringEmailSubject.NEW_INQUIRY_NOTIFICATION,
  //   heading: 'Order',
  //   text: 'New catering inquiry. Order #{order number}',
  //   emailTo: 'Restaurant',
  //   status: 'Inquiry submitted',
  // },
  {
    subject: CateringEmailSubject.PAYMENT_REMINDER,
    heading: 'Friendly reminder',
    text: 'is due for your catering order',
    emailTo: 'Customer',
    status: 'Invoice sent',
    buttonText: 'Go to payment',
  },
  // {
  //   subject: CateringEmailSubject.ORDER_EDIT_CONFIRMATION_REQUEST,
  //   heading: 'Update',
  //   text: 'Please confirm changes to your order',
  //   emailTo: 'Customer',
  //   status: 'Order edited',
  // },
  // {
  //   subject: CateringEmailSubject.POST_EVENT_FEEDBACK_REQUEST,
  //   heading: 'Feedback',
  //   text: 'How was your catering experience?',
  //   emailTo: 'Customer',
  //   status: 'Feedback request',
  // },
];
